'use client';

import AppLayout from '@/components/AppLayout';
import StoricoConfigurazioniContent from './components/StoricoConfigurazioniContent';
import RoleGuard from '@/components/RoleGuard';

export default function StoricoConfigurazioniPage() {
  return (
    <AppLayout>
      <RoleGuard allowedRoles={['super_admin', 'admin_it']}>
        <StoricoConfigurazioniContent />
      </RoleGuard>
    </AppLayout>
  );
}
